import BaseAPI from './base';

class UserService extends BaseAPI {
    changePassword = async (hash, newPassword) => {
      const url = `/users/${hash}/password`;

      return this.patchJson(url, { newPassword });
    }

    getPublicInformationByUsername = async (userName) => {
      const url = `/familyMembers?query=@${userName}&pageIndex=1`;

      return this.getJson(url);
    }

    getPublicInformationBySearch = async (searchValue, index) => {
      const url = `/FamilyMembers?query=${encodeURIComponent(searchValue)}&pageIndex=${index}`;

      return this.getJson(url);
    }

    getPublicGoals= async (userId) => {
      const url = `/users/${userId}/publicGoals`;

      return this.getJson(url);
    }

    getPublicInvestors = async (userId) => {
      const url = `/users/${userId}/PublicInvestors`;

      return this.getJson(url);
    }
}

export default new UserService();
